import { UserStorageUseCaseInterface } from 'application/usecases/UserStorageUseCase';
import { AUTH_ROUTES, PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Page = (props: { userStorageUseCase: UserStorageUseCaseInterface }) => {
    const navigate = useNavigate();

    useEffect(() => {
        const user = props.userStorageUseCase.getUserInfo();
        if (!user) return navigate(AUTH_ROUTES.PATH + '/' + AUTH_ROUTES.SUB.CU_048_01);
        else return navigate(PRIVATE_ROUTES.PATH + '/' + PRIVATE_ROUTES.SUB.CU_002_01);
    });

    return <></>;
};

export default Page;
